import http from './http';

export const reinscripcionesUsuariosPeticion = async (data: FormData) => {
  try {
    return await http.post(
      `/reinscripciones`,
      data,
      {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
      },
      {
        timeout: 10 * 60 * 1000,
      },
    );
  } catch (error) {
    // El toast de error ya lo muestra http.ts a partir de error.response.data.error
    console.error('Error en reinscripcionesUsuariosPeticion', error);
    return null;
  }
};

export const descargarCSVExampleReinscripcionPeticion = async () => {
  try {
    return await http.download(
      `/reinscripciones/plantilla`,
      `reinscripciones-sample.xlsx`,
    );
  } catch (error) {
    console.error('Ocurrió un error al descargar el ejemplo CSV :: ', error);
  }
};

export const inscripcionesUsuariosPeticion = async (data: FormData) => {
  try {
    return await http.post(
      `/inscripciones`,
      data,
      {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
      },
      {
        timeout: 10 * 60 * 1000,
      },
    );
  } catch (error) {
    console.error('Error en inscripcionesUsuariosPeticion', error);
    return null;
  }
};

export const descargarCSVExampleInscripcionPeticion = async () => {
  try {
    return await http.download(
      `/inscripciones/plantilla`,
      `inscripciones-sample.xlsx`,
    );
  } catch (error) {
    console.error('Ocurrió un error al descargar el ejemplo CSV :: ', error);
  }
};
